import defaultEnglishMessages from 'ra-language-english';

export const englishMessages = {
  ...defaultEnglishMessages,
  resources: {
    users: {
      name: 'User |||| Users',
      fields: {
        id: 'ID',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        profession: 'Profession',
        location: 'Location',
        avatarUrl: 'Avatar',
        isVerified: 'Verified',
        twoFactorEnabled: '2FA Enabled',
        followersCount: 'Followers',
        followingCount: 'Following',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
      tabs: {
        general: 'General Information',
        security: 'Security',
        social: 'Social Connections',
        challenges: 'Challenges',
        orders: 'Orders',
      },
      social: {
        followers: 'Followers',
        following: 'Following',
        no_followers: 'No followers',
        no_following: 'No following',
        loading_followers: 'Loading followers...',
        loading_following: 'Loading following...',
        error: 'Error',
      },
      challenges: {
        created_challenges: 'Created Challenges',
        no_challenges: 'No created challenges',
        loading: 'Loading challenges...',
        type: 'Type',
        status: 'Status',
        mode: 'Mode',
        participants: 'Participants',
        current_streak: 'Current Streak',
        best_streak: 'Best Streak',
        created: 'Created',
        start: 'Start',
        end: 'End',
        group: 'Group',
        personal: 'Personal',
      },
      orders: {
        supplement_orders: 'Supplement Orders',
        no_orders: 'No orders',
        loading: 'Loading orders...',
        order_id: 'Order ID',
        quantity: 'Quantity',
        status: 'Status',
        payment: 'Payment',
        paid: 'Paid',
        not_paid: 'Not paid',
        context: 'Context',
        recommendation_reason: 'Recommendation Reason',
        created: 'Created',
        paid_at: 'Paid At',
      },
    },
    challenges: {
      name: 'Challenge |||| Challenges',
      fields: {
        id: 'ID',
        title: 'Title',
        description: 'Description',
        type: 'Type',
        status: 'Status',
        mode: 'Mode',
        author: 'Author',
        participants: 'Participants',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
    },
    supplements: {
      name: 'Supplement |||| Supplements',
      fields: {
        id: 'ID',
        name: 'Name',
        description: 'Description',
        price: 'Price',
        emoji: 'Emoji',
        benefits: 'Benefits',
        duration: 'Duration',
      },
    },
    supplementOrders: {
      name: 'Order |||| Orders',
      fields: {
        id: 'Order ID',
        client: 'Client',
        supplement: 'Supplement',
        quantity: 'Quantity',
        totalPrice: 'Total',
        status: 'Status',
        isPaid: 'Paid',
        createdAt: 'Created',
        paidAt: 'Paid At',
      },
    },
    paymentTransactions: {
      name: 'Payment |||| Payments',
      fields: {
        id: 'ID',
        client: 'Client',
        order: 'Order',
        amount: 'Amount',
        currency: 'Currency',
        status: 'Status',
        method: 'Method',
        provider: 'Provider',
        createdAt: 'Created',
      },
    },
    challengeUpdates: {
      name: 'Event |||| Challenge Events',
      fields: {
        id: 'ID',
        type: 'Type',
        content: 'Content',
        user: 'User',
        challenge: 'Challenge',
        dayNumber: 'Day',
        createdAt: 'Created',
      },
    },
    chatMessages: {
      name: 'Message |||| Chat Messages',
      fields: {
        id: 'ID',
        role: 'Role',
        content: 'Content',
        user: 'User',
        createdAt: 'Created',
      },
    },
  },
  // Challenge types
  challengeTypes: {
    QUIT_SMOKING: 'Quit Smoking',
    QUIT_PORN: 'Quit Porn',
    QUIT_SUGAR: 'Quit Sugar',
    QUIT_ALCOHOL: 'Quit Alcohol',
    EXERCISE: 'Exercise',
    MEDITATION: 'Meditation',
    READING: 'Reading',
    WATER_DRINKING: 'Water Drinking',
    SLEEP_SCHEDULE: 'Sleep Schedule',
    NO_SOCIAL_MEDIA: 'No Social Media',
    CUSTOM: 'Custom',
  },
  // Challenge statuses
  challengeStatuses: {
    ACTIVE: 'Active',
    PAUSED: 'Paused',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
  },
  // Order statuses
  orderStatuses: {
    PENDING: 'Pending',
    PROCESSING: 'Processing',
    SHIPPED: 'Shipped',
    DELIVERED: 'Delivered',
    CANCELLED: 'Cancelled',
  },
  // Payment statuses
  paymentStatuses: {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled',
    REFUNDED: 'Refunded',
  },
  // Payment methods
  paymentMethods: {
    CARD: 'Card',
    PAYPAL: 'PayPal',
    BANK_TRANSFER: 'Bank Transfer',
    CRYPTO: 'Cryptocurrency',
  },
  // Payment providers
  paymentProviders: {
    STRIPE: 'Stripe',
    PAYPAL: 'PayPal',
    BANK: 'Bank',
    CRYPTO: 'Crypto',
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      total_users: 'Total Users',
      total_challenges: 'Total Challenges',
      total_orders: 'Total Orders',
      total_activities: 'Total Activities',
      activities_subtitle: 'Check-ins, status changes',
    },
    charts: {
      user_registration: 'User Registration',
      challenge_types: 'Challenge Types',
      order_statuses: 'Order Statuses',
      activity_types: 'Activity Types',
      daily_activity: 'Daily Activity (30 days)',
    },
  },
  challengeActivityTypes: {
    START: 'Challenge Start',
    CHECKIN: 'Check-in',
    STATUS_CHANGE: 'Status Change',
    COMMENT: 'Comment',
    LIKE: 'Like',
    COMPLETE: 'Completion',
    FAIL: 'Failure',
  },
};
